import React, { useMemo } from 'react';
import { Select } from 'antd';
import { gql } from '@apollo/client';
import { useQuery } from 'hooks/apollo';

const QUERY = gql`
  query {
    currencies { key name }
  }
`;

const CurrencySelect = ({ currencies, ...props }) => {
  const { loading, data } = useQuery(QUERY, {
    fetchPolicy: 'cache-first',
    skip: currencies,
  });

  const options = useMemo(() => {
    if (currencies) {
      return currencies.map(c => ({ value: c, label: c }));
    }

    return data?.currencies?.map(c => ({ value: c.key, label: c.name }));
  }, [currencies, data]);

  return (
    <Select loading={loading} options={options} showSearch optionFilterProp="label" {...props} />
  );
};

export default CurrencySelect;
